/* import __COLOCATED_TEMPLATE__ from './preferred-business-text.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();